import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { PageLoader } from '~/components/page/PageLoader';

export function TutorialsPage() {
  useBreadcrumb('routes/tutorials', 'Tutorials');

  return <PageLoader pageName="tutorials" />;
}
